import { Message, Paginator } from "@twilio/conversations";
import { TwilioConversation } from "~/modules/conversations";





export interface SendTextMessageOptions {
    body: string;
    messageAttributes?: any;
    attachedFiles?: File[];
}





export interface SendEmailMessageOptions {
    messageAttributes?: any;
    subject?: string;
    attachedFiles?: File[];
    htmlBody: string;
    plainTextBody?: string;
}





export interface SendMediaMessageOptions {
    attachedFiles: File[];
    messageAttributes?: any;
}





export enum MessagesDirection {
    Backwards = "backwards",
    Forward = "forward"
}



























export interface Conversation {
    sid: string;

    conversation: TwilioConversation;

    

























    sendMessage(messageOptions: SendTextMessageOptions | SendEmailMessageOptions): Promise<number | null>;

    



























    getMessages(
        pageSize?: number,
        anchorMessageIndex?: number,
        direction?: MessagesDirection
    ): Promise<Paginator<Message>>;

    






















    sendTyping(): Promise<void>;
}
